'use strict';

module.exports = {
    init: function (form) {
        var checkedShippingMethod = $('input[name=dwfrm_shipping_shippingAddress_shippingMethodID]:checked', form);
        var isStorePickUpMethod = checkedShippingMethod.attr('data-pickup') === 'true';

        return {
            isStorePickUpMethod: isStorePickUpMethod,
            storeID: $("input[name='storeId']", form).val(),
            errorMsg: window.sitePrefs.resources.errorSelectStore
        };
    }
};
